import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

@Component({
  selector: 'gas-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrls: ['./status-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasStatusTagComponent {

  @Input()
  public label: string;

  @GasInputBoolean()
  @Input()
  public isActive = false;

  @GasInputBoolean()
  @Input()
  public disabled = false;

  @Output('clicked')
  public clicked$ = new EventEmitter<void>();

  @HostListener('click')
  public handleClick(): void {
    if (!this.disabled) {
      this.clicked$.emit();
    }
  }

}
